import {
  Button,
  IconButton,
  Modal,
  ModalBackdrop,
  ModalBody,
  ModalCloseTrigger,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalPositioner,
  ModalTitle,
  Text,
} from "@commonsku/design-system";
import { XIcon } from "@commonsku/styles";
import React from "react";

interface CustomDomainInformationPopupProps {
  onContinue: () => void;
  onClose: () => void;
}

const CustomDomainInformationPopup = ({
  onContinue,
  onClose,
}: CustomDomainInformationPopupProps) => {
  return (
    <Modal
      closeOnEscape
      closeOnInteractOutside
      modal
      motionPreset="scale"
      placement="center"
      role="dialog"
      scrollBehavior="outside"
      size="lg"
      trapFocus
      open
    >
      <ModalBackdrop />
      <ModalPositioner>
        <ModalContent>
          <ModalHeader px="24px" pt="24px" pb="0">
            <ModalTitle fontSize="24px" fontWeight="semibold" mb={1}>
              Set a custom domain
            </ModalTitle>
          </ModalHeader>
          <ModalBody pb="4">
            <Text>
              To connect a custom domain, you'll need to add a CNAME and TXT
              record at your DNS provider. We'll walk you through the details on
              the next step. DNS updates usually take a few minutes but can take
              up to 72 hours. If verification fails on the first try, wait a bit
              and try again.
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="outline"
              onClick={onClose}
              data-testid="customDomain-information-popup-cancel.btn"
            >
              Cancel
            </Button>
            <Button
              onClick={onContinue}
              data-testid="customDomain-information-popup-continue.btn"
            >
              Continue
            </Button>
          </ModalFooter>
          <ModalCloseTrigger asChild>
            <IconButton
              onClick={onClose}
              size="xl"
              label="Close"
              variant="ghost"
            >
              <XIcon />
            </IconButton>
          </ModalCloseTrigger>
        </ModalContent>
      </ModalPositioner>
    </Modal>
  );
};

export default CustomDomainInformationPopup;
